import { render, staticRenderFns } from "./DefiFMintPushRewardsConfirmation.vue?vue&type=template&id=dbf1212e&"
import script from "./DefiFMintPushRewardsConfirmation.vue?vue&type=script&lang=js&"
export * from "./DefiFMintPushRewardsConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports